module.exports = {
  servicesTelphone: '4006-822-110', //咨询热线号码
  phone: '0571-88265513', //电话
  mail: '31500@chaojima.com', //邮箱
  companyAddress: '杭州市西湖区华星路99号 创业大厦5楼', //公司地址
  //后台组织ID
  organizationId: '4d6a1cc0e1684847a8bbf6955b1de8a2',
  //后台系统ID
  systemId: '93b6c020da474a11b42a418fd5bbbaaf',
  //
  functionList: require('./functionList'),
};
